import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUser, FaCheck, FaTimes } from 'react-icons/fa';
import { addPlayer } from '../utils/api';
import './AddPlayer.css';

const AddPlayer = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  
  // Form state
  const [name, setName] = useState('');
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!name) {
      setError('Spelarens namn måste anges.');
      return;
    }
    
    try {
      setLoading(true);
      const playerData = {
        name,
        username: username || null,
        email: email || null
      };
      
      const response = await addPlayer(playerData);
      
      if (response.error) {
        setError(response.message);
      } else {
        setSuccess(true);
        setError(null);
        
        // Reset form and redirect after 2 seconds
        setTimeout(() => {
          navigate('/players');
        }, 2000);
      }
    } catch (err) {
      setError('Kunde inte lägga till spelare. Försök igen.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="container">
      <div className="page-title">
        <FaUser />
        <h1>Lägg till spelare</h1>
      </div>
      
      {error && <div className="error">{error}</div>}
      {success && (
        <div className="success">
          <FaCheck /> Spelaren har lagts till! Omdirigerar...
        </div>
      )}
      
      <form onSubmit={handleSubmit} className="add-player-form card">
        <div className="form-group">
          <label htmlFor="name" className="form-label">
            Namn *
          </label>
          <input
            type="text"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="form-input"
            placeholder="Ange spelarens namn"
            required
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="username" className="form-label">
            Användarnamn (valfritt)
          </label>
          <input
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="form-input"
            placeholder="Användarnamn för inloggning"
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="email" className="form-label">
            Email (valfritt)
          </label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="form-input"
            placeholder="email@exempel.com"
          />
        </div>
        
        <div className="form-actions">
          <button
            type="button"
            onClick={() => navigate('/players')}
            className="btn cancel-btn"
          >
            <FaTimes /> Avbryt
          </button>
          <button 
            type="submit" 
            className="btn submit-btn" 
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="button-spinner"></span> Sparar...
              </>
            ) : (
              <>
                <FaCheck /> Spara spelare
              </>
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddPlayer; 